const state = {
  active: 0,
  items: [],
  triggered: 0
}

export default state
